import { useEffect, useState } from "react";
import { api } from '@r-and-a-shared-ui/randa-trpc-client';
import { SEOWrapperProps } from "../../../SEOWrapper/SEOWrapper";

export interface ErrorPageData {
  headerText: string;
  titleText: string;
  subtitleText: string;
  logos: Array<{
    logoImageUrl: string;
    logoImageAlt: string;
    logoLink: string;
    logoWidth?: number;
    logoHeight?: number;
  }>;
  sideImage?: {
    url: string;
    name: string;
    width: number;
    height: number;
  };
  seoData?: SEOWrapperProps;
}

export function useErrorPage(
  pageCodename: string,
  defaultHeaderText: string,
  defaultTitleText: string,
  defaultSubtitleText: string,
) {
  const [errorPageData, setErrorPageData] = useState<ErrorPageData | null>(null);

  const { data: queryData, isLoading } = api.kontent.itemWithLinkedItems.useQuery({
    codename: pageCodename,
    depthParameter: 1,
  });
  
  useEffect(() => {
    if (!queryData) return;
  
    const headerText = queryData?.elements?.header?.value || defaultHeaderText;
    const titleText = queryData?.elements?.title?.value || defaultTitleText;
    const subtitleText = queryData?.elements?.subtitle?.value || defaultSubtitleText;
  
    const logos = (queryData?.elements?.logos as any).linkedItems.map((logoItem: any) => ({
      logoImageUrl: logoItem.elements.logo_image.value[0].url,
      logoImageAlt: logoItem.elements.logo_image.value[0].name,
      logoLink: logoItem.elements.external_link.value,
      logoWidth: logoItem.elements.logo_image.value[0].width || 75,
      logoHeight: logoItem.elements.logo_image.value[0].height || 50,
    }));
  
    const sideImage = queryData?.elements?.side_image?.value?.[0]
      ? {
        url: queryData.elements.side_image.value[0].url,
        name: queryData.elements.side_image.value[0].name,
        width: queryData.elements.side_image.value[0].width,
        height: queryData.elements.side_image.value[0].height,
      }
      : undefined;

    const seoData = {
      title: queryData?.elements?.seo__meta_title?.value,
      noindex: true,
      nofollow: true,
    }
  
    setErrorPageData({
      headerText,
      titleText,
      subtitleText,
      logos,
      sideImage,
      seoData,
    });
  }, [queryData, defaultHeaderText, defaultTitleText, defaultSubtitleText]);
  
  
  return { errorPageData, isLoading };
}